import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiMenu,
  FiX,
  FiActivity,
  FiInfo,
  FiChevronDown
} from 'react-icons/fi';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  const calculatorLinks = [
    { to: '/bmi-calculator', label: 'BMI', emoji: '📏' },
    { to: '/calorie-intake-calculator', label: 'Calories', emoji: '🔥' },
    { to: '/ideal-weight-calculator', label: 'Weight', emoji: '⚖️' },
    { to: '/calories-burned-calculator', label: 'Burned', emoji: '💪' },
  ];

  return (
    <>
      <header className={`app-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-inner">
          <Link to="/" className="header-logo">
            <div className="logo-icon">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="8" fill="#10B981"/>
                <path d="M10 16C10 12.686 12.686 10 16 10C19.314 10 22 12.686 22 16" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                <path d="M10 16C10 19.314 12.686 22 16 22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="4 4"/>
                <circle cx="16" cy="16" r="2" fill="white"/>
              </svg>
            </div>
            <span className="logo-text">Kalorees</span>
          </Link>

          <nav className="header-nav">
            <Link to="/" className={`nav-pill ${isActive('/') ? 'active' : ''}`}>
              <FiHome size={16} />
              <span>Home</span>
            </Link>
            <div className="nav-dropdown">
              <button className={`nav-pill ${calculatorLinks.some(l => isActive(l.to)) ? 'active' : ''}`}>
                <FiActivity size={16} />
                <span>Tools</span>
                <FiChevronDown size={14} />
              </button>
              <div className="dropdown-panel">
                {calculatorLinks.map(link => (
                  <Link key={link.to} to={link.to} className={`dropdown-item ${isActive(link.to) ? 'active' : ''}`}>
                    <span className="dropdown-emoji">{link.emoji}</span>
                    <span>{link.label}</span>
                  </Link>
                ))}
              </div>
            </div>
            <Link to="/about" className={`nav-pill ${isActive('/about') ? 'active' : ''}`}>
              <FiInfo size={16} />
              <span>About</span>
            </Link>
          </nav>

          <button
            className="mobile-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </div>
      </header>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />
      )}

      {/* Mobile menu */}
      <div className={`mobile-menu ${mobileOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <span className="mobile-menu-title">Menu</span>
          <button onClick={() => setMobileOpen(false)} className="mobile-menu-close">
            <FiX size={20} />
          </button>
        </div>
        <nav className="mobile-nav">
          <Link to="/" className={`mobile-nav-item ${isActive('/') ? 'active' : ''}`}>
            <FiHome size={18} />
            <span>Home</span>
          </Link>
          <div className="mobile-nav-section">Calculators</div>
          {calculatorLinks.map(link => (
            <Link key={link.to} to={link.to} className={`mobile-nav-item ${isActive(link.to) ? 'active' : ''}`}>
              <span className="mobile-emoji">{link.emoji}</span>
              <span>{link.label}</span>
            </Link>
          ))}
          <div className="mobile-nav-section">Info</div>
          <Link to="/about" className={`mobile-nav-item ${isActive('/about') ? 'active' : ''}`}>
            <FiInfo size={18} />
            <span>About</span>
          </Link>
        </nav>
      </div>

      {/* Bottom calculator dock on mobile */}
      <div className="calculator-dock">
        {calculatorLinks.map(link => (
          <Link
            key={link.to}
            to={link.to}
            className={`dock-item ${isActive(link.to) ? 'active' : ''}`}
          >
            <span className="dock-emoji">{link.emoji}</span>
            <span className="dock-label">{link.label}</span>
          </Link>
        ))}
      </div>
    </>
  );
};

export default Header;
